import React from "react";
import { ThemeProvider } from "@mui/styles";
import Routes from "@containers/Routes";
import theme from "@/theme";
import { GlobalContextWrapper } from "@contexts/Global";
import CssBaseline from "@mui/material/CssBaseline";

const App = () => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalContextWrapper>
          <Routes />
        </GlobalContextWrapper>
      </ThemeProvider>
    </>
  );
};

export default App;
